<template>
  <div class="row">
    <div class="col s10">
      <div class="col s12 z-depth-1 white">
        <div class="row">
          <div class="left" style="padding-top: 10px;">
            <span class="title" style="padding-left: 11px;">{{ this.$t('analysis.xyAnalysis') }}</span>
          </div>
        </div>
        <AnalysisGraph
          :rail-object="railObject"
          :api-data="apiData"
          :x-axis="xAxis"
          :y-axis="yAxis"
          :x-axis-translated="getTranslationKey(xAxis)"
          :y-axis-translated="getTranslationKey(yAxis)"
          :unit="getUnit(yAxis)"/>
      </div>
    </div>
    <div class="col s2">
      <div class="control col s12 z-depth-1 white">
        <div class="analysis-control">
          <div class="input-field">
            {{ this.$t('analysis.xAxis') }}:
            <select v-model="xAxis" class="browser-default">
              <option v-for="(property, index) in propertiesPlusDate" :value="property" :key="index">
                {{ getTranslationKey(property) }}
              </option>
            </select>
          </div>
          <div class="input-field">
            {{ this.$t('analysis.yAxis') }}:
            <select v-model="yAxis" class="browser-default">
              <option v-for="property in analysisProperties" :value="property" :key="property">
                {{ getTranslationKey(property) }}
              </option>
            </select>
          </div>
          <div
            class="input-field right"
            :title="$t('analysis.noSwitchDate')"
          >
            <button
              :disabled="xAxis === 'Date'"
              class="waves-effect waves-light btn buttonbg"
              @click="switchXY"
            >
              {{ $t('analysis.switchxy') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AnalysisGraph from './XYAnalysisGraph'
import moment from 'moment'
import SwitchApi from '@/services/api/switch/SwitchApi'
import AlarmService from '@/services/AlarmService'

export default {
  name: 'XYAnalysis',
  components: {
    AnalysisGraph
  },
  props: {
    railObject: {
      required: true
    },
    timeSelection: {
      required: true
    }
  },
  data () {
    return {
      xAxis: 'Date',
      yAxis: 'PowerTotal',
      properties: [],
      apiData: [],
      sensors: []
    }
  },
  created: function () {
    this.getSensor()
    this.getAnalysisData()
  },
  computed: {
    analysisProperties: function () {
      const exclude = { 'MeasurementDateTime': true, 'RailObjectId': true, 'MeasurementId': true, 'Direction': true, 'InControl': true, 'Date': true }
      const excludeSimpleSensor = { 'MeasurementDateTime': true, 'RailObjectId': true, 'MeasurementId': true, 'Direction': true, 'InControl': true, 'Date': true, 'Alarm': true, 'PowerStart': true, 'PowerMid': true, 'PowerEnd': true, 'PowerDiff': true, 'PowerTotal': true, 'AmpMiddle': true }

      let result = []

      if (this.sensors === null || this.sensors.ConfigSensor === null || this.sensors.ConfigSensor.UnitOfMeasure === null) {
        return result
      }

      if (this.sensors.ConfigSensor.UnitOfMeasure.toLowerCase() === 'bar'.toLowerCase() ||
          this.sensors.ConfigSensor.UnitOfMeasure.toLowerCase() === 'mm'.toLowerCase() ||
          this.sensors.ConfigSensor.UnitOfMeasure.toLowerCase() === 'kN'.toLowerCase() ||
          this.sensors.ConfigSensor.UnitOfMeasure.toLowerCase() === 'deg'.toLowerCase() ||
          this.sensors.ConfigSensor.UnitOfMeasure.toLowerCase() === 'dB'.toLowerCase() ||
          this.sensors.ConfigSensor.UnitOfMeasure.toLowerCase() === 'G'.toLowerCase()) {
        this.properties.forEach(x => {
          if (!excludeSimpleSensor[x]) {
            result.push(x)
          }
        })
      } else {
        this.properties.forEach(x => {
          if (!exclude[x]) {
            result.push(x)
          }
        })
      }
      return result
    },
    propertiesPlusDate: function () {
      const exclude = { 'MeasurementDateTime': true, 'RailObjectId': true, 'MeasurementId': true, 'Direction': true, 'InControl': true }
      const excludeSimpleSensor = { 'MeasurementDateTime': true, 'RailObjectId': true, 'MeasurementId': true, 'Direction': true, 'InControl': true, 'Alarm': true, 'PowerStart': true, 'PowerMid': true, 'PowerEnd': true, 'PowerDiff': true, 'PowerTotal': true, 'AmpMiddle': true }
      let result = []

      if (this.sensors === null || this.sensors.ConfigSensor === null || this.sensors.ConfigSensor.UnitOfMeasure === null) {
        return result
      }

      if (this.sensors.ConfigSensor.UnitOfMeasure.toLowerCase() === 'bar'.toLowerCase() ||
          this.sensors.ConfigSensor.UnitOfMeasure.toLowerCase() === 'mm'.toLowerCase() ||
          this.sensors.ConfigSensor.UnitOfMeasure.toLowerCase() === 'kN'.toLowerCase() ||
          this.sensors.ConfigSensor.UnitOfMeasure.toLowerCase() === 'deg'.toLowerCase() ||
          this.sensors.ConfigSensor.UnitOfMeasure.toLowerCase() === 'dB'.toLowerCase() ||
          this.sensors.ConfigSensor.UnitOfMeasure.toLowerCase() === 'G'.toLowerCase()) {
        this.properties.forEach(x => {
          if (!excludeSimpleSensor[x]) {
            result.push(x)
          }
        })
      } else {
        this.properties.forEach(x => {
          if (!exclude[x]) {
            result.push(x)
          }
        })
      }
      return result
    }
  },
  methods: {
    switchXY () {
      if (this.xAxis !== 'date') {
        const temp = this.xAxis
        this.xAxis = this.yAxis
        this.yAxis = temp
      }
    },
    getAnalysisData () {
      SwitchApi.getSwitchAnalysisData(
        this.railObject.RailObjectId,
        moment(this.timeSelection.start).format('YYYY-MM-DDTHH:mm:ss'),
        moment(this.timeSelection.end).format('YYYY-MM-DDTHH:mm:ss'))
        .then(result => {
          this.apiData = result.data
          if (this.apiData[0]) {
            this.properties = Object.keys(this.apiData[0])
          }
        })
    },
    getTranslationKey (val) {
      switch (val) {
        case 'Date':
          return this.$t('views.alarmlist.date')
        case 'Temperature':
          return this.$t('views.switch.temperature')
        case 'Engine':
          return this.$t('views.switch.engines')
        case 'Duration':
          return this.$t('views.switch.duration')
        case 'Alarm':
          return this.$t('alarm')
        case 'AmpStart':
          if (this.sensors === null) {
            return 'AmpStart'
          }
          switch (this.sensors.ConfigSensor.UnitOfMeasure.toLowerCase()) {
            case 'bar'.toLowerCase():
              return this.$t('views.switch.pressurestart')
            case 'mm'.toLowerCase():
              return this.$t('views.switch.positionstart')
            case 'kN'.toLowerCase():
              return this.$t('views.switch.forcestart')
            case 'deg'.toLowerCase():
              return this.$t('views.switch.temperature') + ' ' + this.$t('views.switch.sections.start')
            case 'dB'.toLowerCase():
              return this.$t('views.switch.noicestart')
            case 'G'.toLowerCase():
              return this.$t('views.switch.forcestart')
            default:
              return 'AmpStart'
          }
        case 'AmpEnd':
          if (this.sensors === null) {
            return 'AmpEnd'
          }
          switch (this.sensors.ConfigSensor.UnitOfMeasure.toLowerCase()) {
            case 'bar'.toLowerCase():
              return this.$t('views.switch.pressureend')
            case 'mm'.toLowerCase():
              return this.$t('views.switch.positionend')
            case 'kN'.toLowerCase():
              return this.$t('views.switch.forceend')
            case 'deg'.toLowerCase():
              return this.$t('views.switch.temperature') + ' ' + this.$t('views.switch.sections.end')
            case 'dB'.toLowerCase():
              return this.$t('views.switch.noiceend')
            case 'G'.toLowerCase():
              return this.$t('views.switch.forceend')
            default:
              return 'AmpEnd'
          }
        default:
          return val
      }
    },
    getSensor () {
      if (this.railObject.RailObjectId) {
        this.sensors = null
        AlarmService.GetSensorsByRailobjectId(this.railObject.RailObjectId).then(result => {
          result.data.forEach(el => {
            if (el.RailObjectId === this.railObject.RailObjectId) {
              this.sensors = el
            }
          })
        })
      }
    },
    getUnit (val) {
      if (this.sensors === null || this.sensors.ConfigSensor === null || this.sensors.ConfigSensor.UnitOfMeasure === null) {
        return ''
      }
      switch (val) {
        case 'PowerStart':
        case 'PowerMid':
        case 'PowerEnd':
        case 'PowerDiff':
        case 'PowerTotal':
        case 'Engines':
        case 'Date':
        case 'Alarm':
          return ' '
        case 'Temperature':
          return '(°C)'
        case 'Duration':
          return '(s)'
        default:
          return '(' + this.sensors.ConfigSensor.UnitOfMeasure + ')'
      }
    }
  },
  watch: {
    railObject () {
      this.getSensor()
      this.getAnalysisData()
    },
    timeSelection () {
      this.getSensor()
      this.getAnalysisData()
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/switch/analysis/XYAnalysis.vue